import React from 'react';
import { useTranslation } from 'Shared/Hooks/useTranslation';

import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';

import mixpanel from 'Jsx/Utils/mixpanelTracking';
import * as EVENTS from '../../events';
import useMembership from 'Jsx/CourseDetail/components/MembershipMode/hooks/useMembership';
import locales from '../../i18n/localeEs';

const translations = locales.es;

const MembershipPromo = () => {
  const { t } = useTranslation();
  const { membership, loading, error } = useMembership('LANDING_CASE_B');

  if (membership && !loading && !error) {
    if (membership) {
      const Title = (
        <div className="mb-8 sm:mb-48 sm:w-7/12">
          <p className="sm:hidden font-h2 text-white">
            {t('PREMIUM_COPY', {
              defaultValue: translations.PREMIUM_COPY,
            })}
          </p>
          <p className="hidden sm:block font-h4 text-white">
            {t('PREMIUM_COPY')}
          </p>
        </div>
      );

      return (
        <div className="bg-base-main p-24 sm:p-40 sm:max-w">
          {Title}
          <div className="sm:flex sm:items-center">
            <div className="flex items-center mb-24 sm:mb-0">
              <p className="font-h4 text-white">
                {membership.prices.currencySymbol}{' '}
                {membership.prices.total.toLocaleString()}
              </p>
              <p className="ml-8 font-subtitle4 text-gray-dark">
                /{' '}
                {t('YEARLY', {
                  defaultValue: translations.YEARLY,
                })}
              </p>
            </div>
            <PrimaryButton
              className="sm:max-w-280 sm:ml-auto"
              full
              size="l"
              onClick={() => {
                mixpanel.track(EVENTS.BUY_MEMBERSHIP, {
                  origin: 'Promo section',
                });
                window.open(membership.urlCheckout);
              }}
              label={t('BECOME_PREMIUM', {
                defaultValue: translations.BECOME_PREMIUM,
              })}
            />
          </div>
        </div>
      );
    }

    return null;
  }

  return null;
};

export default MembershipPromo;
